export default "__VITE_ASSET__ClOp1B_0__";